import _Loading from "@alifd/next/lib/loading";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { PureComponent } from 'react';
import TreeView from './tree';
import './style.less';
import Filter from './filter';
export var Pane = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Pane, _PureComponent);
  function Pane(props) {
    var _this$props$treeMaste, _this$props$treeMaste2, _this$props$treeMaste3, _this$props$treeMaste4, _this$props$treeMaste5, _this$props$treeMaste6;
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.controller = void 0;
    _this.simulatorRendererReadyDispose = void 0;
    _this.changeDocumentDispose = void 0;
    _this.removeDocumentDispose = void 0;
    _this.changeTree = function () {
      _this.setState({
        tree: _this.props.treeMaster.currentTree
      });
    };
    var controller = props.controller,
      treeMaster = props.treeMaster;
    _this.controller = controller;
    _this.state = {
      tree: treeMaster.currentTree
    };
    _this.simulatorRendererReadyDispose = (_this$props$treeMaste = _this.props.treeMaster.pluginContext) === null || _this$props$treeMaste === void 0 ? void 0 : (_this$props$treeMaste2 = _this$props$treeMaste.project) === null || _this$props$treeMaste2 === void 0 ? void 0 : _this$props$treeMaste2.onSimulatorRendererReady(_this.changeTree);
    _this.changeDocumentDispose = (_this$props$treeMaste3 = _this.props.treeMaster.pluginContext) === null || _this$props$treeMaste3 === void 0 ? void 0 : (_this$props$treeMaste4 = _this$props$treeMaste3.project) === null || _this$props$treeMaste4 === void 0 ? void 0 : _this$props$treeMaste4.onChangeDocument(_this.changeTree);
    _this.removeDocumentDispose = (_this$props$treeMaste5 = _this.props.treeMaster.pluginContext) === null || _this$props$treeMaste5 === void 0 ? void 0 : (_this$props$treeMaste6 = _this$props$treeMaste5.project) === null || _this$props$treeMaste6 === void 0 ? void 0 : _this$props$treeMaste6.onRemoveDocument(_this.changeTree);
    return _this;
  }
  var _proto = Pane.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$simulatorRender, _this$changeDocumentD, _this$removeDocumentD;
    this.controller.purge();
    (_this$simulatorRender = this.simulatorRendererReadyDispose) === null || _this$simulatorRender === void 0 ? void 0 : _this$simulatorRender.call(this);
    (_this$changeDocumentD = this.changeDocumentDispose) === null || _this$changeDocumentD === void 0 ? void 0 : _this$changeDocumentD.call(this);
    (_this$removeDocumentD = this.removeDocumentDispose) === null || _this$removeDocumentD === void 0 ? void 0 : _this$removeDocumentD.call(this);
  };
  _proto.render = function render() {
    var _this2 = this;
    var tree = this.state.tree;
    if (!tree) {
      return /*#__PURE__*/React.createElement("div", {
        className: "lc-outline-pane"
      }, /*#__PURE__*/React.createElement("p", {
        className: "lc-outline-notice"
      }, /*#__PURE__*/React.createElement(_Loading, {
        style: {
          display: 'block',
          marginTop: '40px'
        },
        tip: this.props.treeMaster.pluginContext.intl('Initializing')
      })));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "lc-outline-pane"
    }, !this.props.hideFilter && /*#__PURE__*/React.createElement(Filter, {
      tree: tree
    }), /*#__PURE__*/React.createElement("div", {
      ref: function ref(shell) {
        return _this2.controller.mount(shell);
      },
      className: "lc-outline-tree-container " + (this.props.hideFilter ? 'lc-hidden-outline-filter' : '')
    }, /*#__PURE__*/React.createElement(TreeView, {
      key: tree.id,
      tree: tree
    })));
  };
  return Pane;
}(PureComponent);